<template>
  <div class="earningsDetails">
    <van-sticky>
      <div
        class="earningsDetailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle"
          >{{ data.calc_type == 1 ? "增加" : "扣减" }}明细</span
        >
      </div>
    </van-sticky>
    <div class="content">
      <div class="card top">
        <span>收益{{ data.calc_type == 1 ? "增加" : "扣减" }}</span>
        <h3>{{ data.calc_type == 1 ? "+" : "-" }}{{ data.amount }}</h3>
      </div>
      <div class="card mid">
        <h3>提现信息</h3>
        <div class="item">
          <div class="itemLeft">
            <span>订单编号</span>
          </div>
          <div class="itemRight">
            <img
              @click="copy()"
              id="copycode"
              :data-clipboard-text="data.order_sn"
              src="./../../../assets/decoration/copy.png"
              alt=""
            />
            <span>{{ data.order_sn }}</span>
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <span>操作时间</span>
          </div>
          <div class="itemRight">
            <span>{{ data.created_at }}</span>
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <span>备注</span>
          </div>
          <div class="itemRight">
            <span>{{ data.remark }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  data() {
    return {
      isiOSX: false,
      data: {},
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.data) {
      this.data = this.$route.query.data;
    }
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less">
.earningsDetails {
  min-height: 100%;
  background: #f5f6ff;
  .earningsDetailsNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    .card {
      background: #ffffff;
      border-radius: 12px;
      padding: 24px;
      margin: 12px 16px 0;
      h3 {
        margin: 0;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
      }
      .item {
        font-size: 14px;
        line-height: 21px;
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        .itemLeft {
          display: flex;
          flex-shrink: 0;
          span {
            color: #999999;
            flex-shrink: 0;
          }
          p {
            color: #333333;
            word-break: break-all;
          }
          img {
            width: 16px;
            height: 16px;
            margin-left: 6px;
            margin-top: 2.5px;
          }
        }
        .itemRight {
          display: flex;
          align-items: center;
          margin-left: 12px;
          justify-content: flex-end;
          span {
            color: #333333;
            text-align: right;
          }
          img {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
    .top {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 14px;
        color: #999999;
        line-height: 20px;
      }
      h3 {
        font-size: 26px;
        color: #333333;
        line-height: 33px;
        margin: 16px 5px 16px 0;
      }
      p {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
    }
  }
}
</style>